// @flow

import React from 'react';

type Props = {
  img: string,
  text: string,
  subtext: string,
  tooltip: boolean,
};

class KeyFigure extends React.PureComponent<Props> {
  render() {
    return (
      <div className="key-figure">
        <div className="key-media-container">
          <div className="media">
            {this.props.img &&
              <img className="imgIcon" src={this.props.img} alt="key figure icon" />
            }
          </div>
        </div>
        <div className="data">
          <span className="text">{this.props.text}</span>
          {this.props.subtext &&
            <span className="subtext">{this.props.subtext}</span>
          }
        </div>
        {this.props.tooltip &&
        <span className="keyfigure-tooltip">{this.props.text}</span>
        }
      </div>
    );
  }
}

export default KeyFigure;
